/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Canceled_Edit_ErrorInputs */

const en_task_canceled_edit_error = /** @type {(inputs: Task_Canceled_Edit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This activity is canceled. Reopen it explicitly before making changes.`)
};

const pt_br2_task_canceled_edit_error = /** @type {(inputs: Task_Canceled_Edit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta atividade está cancelada. Reabra-a antes de fazer alterações.`)
};

/**
* | output |
* | --- |
* | "This activity is canceled. Reopen it explicitly before making changes." |
*
* @param {Task_Canceled_Edit_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_canceled_edit_error = /** @type {((inputs?: Task_Canceled_Edit_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Canceled_Edit_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_canceled_edit_error(inputs)
	return pt_br2_task_canceled_edit_error(inputs)
});